import React  from 'react';
import {connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { logout } from '../../../store/actions/AuthActions';
import { isAuthenticated } from '../../../store/selectors/AuthSelectors';

function LogoutPage(props){
    const dispatch = useDispatch();
    const { t } = useTranslation();

    function onLogout() {
       dispatch(logout(props.history));
    }
    return(
        <>
            <a className="dropdown-item ai-icon" onClick={onLogout}>
                <span style={{fontSize: '1.2rem', marginLeft: '5px'}}>🚪</span>
                <span className="text-black" style={{marginLeft: '15px'}}>{t('logout')}</span>
            </a>
        </>
    )
} 
const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(LogoutPage));